import React from 'react';
import Timestamp from '../../components/Timestamp';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import { PostType } from '../../graphql/generated/graphql';
import useIsLayoutSize from '../utils/useIsLayoutSize';
import { LayoutSize } from '../utils/useLayoutSize';

const POST_FRAGMENT = gql(`
  fragment PostStateBarLabel_post on Post {
    id
    archivedAt
    publishedAt
    editedAt
    type
    externalPost {
      id
    }
  }
`);

interface PostStateBarLabelProps {
  post: DocumentType<typeof POST_FRAGMENT>;
  isPublic: boolean;
  isPublishedInPublicTopic: boolean;
}

const PostStateBarLabel = ({
  post,
  isPublic,
  isPublishedInPublicTopic,
}: PostStateBarLabelProps) => {
  const isMobile = useIsLayoutSize(LayoutSize.mobile);

  const postTypeName = (() => {
    const prefix = post.publishedAt ? '' : 'Draft ';
    if (post.type === PostType.Template) return `${prefix}Template`;
    if (post.type === PostType.Variant) return `${prefix}Variant`;
    return post.publishedAt ? 'Post' : 'Draft';
  })();

  const typeWithPrefix = `${isPublic && !isMobile ? 'Public ' : ''}${postTypeName}`;
  if (post.archivedAt) {
    return (
      <div>
        <strong>{typeWithPrefix}</strong> archived{' '}
        <Timestamp
          date={post.archivedAt}
          format={isMobile ? 'short' : 'default'}
        />
      </div>
    );
  }

  if (post.externalPost) {
    return (
      <div>
        <strong>{typeWithPrefix}</strong> synced{' '}
        <Timestamp
          date={post.editedAt}
          format={isMobile ? 'short' : 'default'}
        />
      </div>
    );
  }

  return (
    <div>
      <strong>{typeWithPrefix}</strong>
      {isPublishedInPublicTopic &&
        !isPublic &&
        !!post.publishedAt &&
        ' in public topic'}
    </div>
  );
};

export default PostStateBarLabel;
